import { IdcardOutlined } from "@ant-design/icons";
import { Button, Descriptions, Form, Input, InputNumber, Modal, Switch } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { downloadFile } from "../common/common";
import PermissionRequired from "../common/PermissionRequired";
import ReadBadge from "./ReadBadge";

const SetBadgeModal = ({ open, employeeId, onCancel, onFinish }) => {
    const handleOnFinish = (form) => {
        axiosInstance
            .put(`employee/${employeeId}/badge`, { badgeId: form.badgeId })
            .then(() => onFinish(form));
    };

    const [form] = Form.useForm();
    const isManualMode = Form.useWatch("manualMode", form);

    useEffect(() => {
        document.body.style.overflow = "inherit";
        if (!open) form.resetFields();
    }, [open]);
    return (
        <Modal
            destroyOnClose
            open={open}
            title="Imposta numero badge"
            onCancel={onCancel}
            okButtonProps={{ htmlType: "submit", form: "setBadgeForm" }}
        >
            <Form
                id="setBadgeForm"
                form={form}
                onFinish={handleOnFinish}
                layout="vertical"
                style={{ marginTop: 20 }}
            >
                <Form.Item name={"manualMode"} valuePropName="checked" label="Inserimento manuale">
                    <Switch title="test"/>
                </Form.Item>
                <Form.Item name={"badgeId"} label="Numero badge">
                    {isManualMode ? (
                        <InputNumber style={{ width: "100%" }} controls={false} precision={0} />
                    ) : (
                        <ReadBadge />
                    )}
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default function ({ employee }) {
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (employee) setData(employee);
    }, [employee]);

    return (
        <>
            <SetBadgeModal
                employeeId={data.id}
                open={open}
                onCancel={() => setOpen(false)}
                onFinish={(res) => {
                    setOpen(false);
                    setData({ ...data, ...res });
                }}
            />
            <Descriptions
                extra={
                    <Button
                        type="primary"
                        icon={<IdcardOutlined />}
                        onClick={() => {
                            downloadFile(`employee/${data.id}/badge`);
                        }}
                    >
                        Stampa badge
                    </Button>
                }
            >
                <Descriptions.Item label="Numero badge">
                    {data.badgeId ?? <i>Non impostato</i>}{" "}
                    <PermissionRequired name="employee.setBadge">
                        <Button size="small" type="link" onClick={() => setOpen(true)}>
                            Modifica
                        </Button>
                    </PermissionRequired>
                </Descriptions.Item>
            </Descriptions>
        </>
    );
}
